module.exports = __webpack_public_path__ + "img/错时共享.14af3592.png";